import { styled } from "sharedUI/styles";

export const SectionHeaderStyle = styled.div<{ bold: boolean }>`
    position: relative;
    display: flex;
    align-items: center;

    .titles {
        flex-grow: 1;

        h4 {
            font-size: 19px;
            font-weight: 800;
            color: ${p => p.theme.textDark};
        }

        .subtitle {
            margin-top: 4px;
            font-size: 13px;
            color: ${p => p.theme.textPale};

            a {
                color: ${p => p.theme.blue};
            }
        }
    }

    margin-top: 29px;
    margin-bottom: 17px;
`;
